import { createSelector } from 'reselect'
import { RootState } from '../types'

export const watchStateSelector = (state: RootState) => state.watch

export const watchEidSelector = createSelector(watchStateSelector, watch => watch.eid)

export const watchImeiSelector = createSelector(watchStateSelector, watch => watch.imei)

export const primaryDeviceIccidSelector = createSelector(watchStateSelector, watch => watch.primaryDeviceIccid)

export const isWatchDataAvailableSelector = createSelector(
  [watchEidSelector, primaryDeviceIccidSelector],
  (watchEid, primaryDeviceIccid) => !!watchEid && !!primaryDeviceIccid
)
